import { LinkTo } from "@ember/routing";
import IconsChevronRight from "glesys-controlpanel/components/icons/chevron-right";
import Header from "glesys-controlpanel/components/entity/header";
import Fields from "glesys-controlpanel/components/entity/fields";
import Menu, { MenuAnchor } from "glesys-controlpanel/components/entity/menu";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div
    class="relative [anchor-scope:all] border border-gray-200 bg-white rounded-sm text-base"
    {{mergeClasses}}
    ...attributes
  >
    <LinkTo
      class="group block cursor-pointer rounded-sm hover:bg-gray-50 {{if @hasFields 'rounded-b-none'}}"
      aria-label={{@linkLabel}}
      data-test-entity-link
      @route={{@route}}
      @model={{@model}}
    >
      <Header @title={{@title}} @key={{@key}} @workflowState={{@workflowState}} @managedHosting={{@managedHosting}}>
        {{#if @hasActions}}
          <MenuAnchor />
        {{/if}}
        <span
          class="w-9 h-8 flex items-center justify-center rounded-sm bg-white border border-gray-200 text-gray-600 group-hover:border-gray-300 group-hover:text-gray-800"
          data-test-entity-chevron
        >
          <IconsChevronRight aria-hidden="true" />
        </span>
      </Header>
    </LinkTo>
    {{#if @hasActions}}
      <Menu @title={{@title}}>
        {{yield to="actions"}}
      </Menu>
    {{/if}}
    {{#if @hasFields}}
      <Fields @status={{@status}}>
        {{yield to="fields"}}
      </Fields>
    {{/if}}
  </div>
</template>
